import { CSSProperties } from "react";

export const noTargets: CSSProperties = {
  fontSize: "14px",
  fontStyle: "italic",
  marginTop: "10px",
  marginBottom: "10px",
};
